// This component serves as a wrapper around each Form and decides whether to show or hide the
// form based on the current step.

import React, { useContext } from "react";
import { StateContext } from "../bepaal-statuut/BepaalStatuut";

const Step = (props: {
  name: string;
  children: React.ReactChild | React.ReactChild[];
  // roomForNavigationButtons?: boolean;
}) => {
  const state = useContext(StateContext);

  // const roomForNavigationButtons = props.roomForNavigationButtons ?? true;

  return (
    // this div hides and shows the step
    <div
      style={{
        display: state?.matches(props.name) ? "block" : "none",
        width: "100%",
        // paddingBottom: roomForNavigationButtons ? "90px" : "0px", // height of the navigation buttons
      }}
    >
      {/* <Container maxWidth="md">{props.children}</Container> */}
      {props.children}
    </div>
  );
};

export default Step;
